// extracted by mini-css-extract-plugin
export default {"modal":"bSnZaZ","wrapper":"QF1HZE"};